// extracted by mini-css-extract-plugin
export default {"search":"style_search__9ycbA","button":"style_button__bTaNw","searchResults":"style_searchResults__cZ2l3"};